export const CHAT_LIST = "CHAT_LIST";
export const SET_SENDER_DETAIL = "SET_SENDER_DETAIL";
